"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const CheckboxList_1 = __importDefault(require("components/cosmos/checkbox-list/CheckboxList"));
const CheckboxListItem_1 = __importDefault(require("components/cosmos/checkbox-list/CheckboxListItem"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const defaultClass_1 = __importDefault(require("components/defaultClass"));
const inputCardRadio_1 = require("components/inputCardRadio");
const translationContext_1 = require("configs/translationContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const types_1 = require("modules/content/dripping/types");
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile,
    classType: stores.DrippingFormStore.classType,
    selectedClasses: stores.DrippingFormStore.selectedClasses,
    classes: stores.DrippingStore.classesForDripping
});
const ClassSettings = ({ isMobile, classType, selectedClasses, classes, drippings, drippingKey }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const selectedClassesIds = selectedClasses.map(({ id }) => id);
    const { otherClassesBeingUsedIds, hasSomeDrippingClass } = (0, react_1.useMemo)(() => {
        const otherDrippings = drippings.filter((item) => item.key !== drippingKey);
        const otherClassesBeingUsedIds = otherDrippings.flatMap((item) => {
            return item.classes.map(({ hashId }) => hashId);
        });
        return {
            otherClassesBeingUsedIds,
            hasSomeDrippingClass: otherDrippings.length > 0
        };
    }, [drippings, drippingKey]);
    const CLASS_OPTIONS = [
        {
            value: types_1.ClassTypes.All,
            ...(hasSomeDrippingClass
                ? { tooltipTitle: t('dripping_2.new.classes.all.alert') }
                : { tooltipTitle: '' }),
            title: t('dripping_2.new.classes.all.title'),
            description: t('dripping_2.new.classes.all.description'),
            isDisabled: hasSomeDrippingClass
        },
        {
            value: types_1.ClassTypes.Specific,
            tooltipTitle: '',
            title: t('dripping_2.new.classes.specific.title'),
            description: t('dripping_2.new.classes.specific.description'),
            isDisabled: false
        }
    ];
    const handleCardChange = (newClassType) => {
        stores_1.DrippingFormStore.setClassType(newClassType);
    };
    const handleClassItemChange = (classItem, isChecked) => {
        stores_1.DrippingFormStore.setSelectedClasses(classItem, isChecked);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "_mt-8", children: [(0, jsx_runtime_1.jsx)("p", { className: "_text-3 _text-gray-900 _font-weight-light _mt-0 _mb-1", children: t('general.classes') }), (0, jsx_runtime_1.jsx)("span", { className: "_text-gray-500", children: t('dripping_2.new.classes.description') })] }), (0, jsx_runtime_1.jsx)("div", { className: "_d-flex _flex-column _flex-lg-row _mt-3 _gap-3", children: CLASS_OPTIONS.map((item) => {
                    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { position: tooltip_1.default.TOOLTIP_POSITION.TOP, content: item.tooltipTitle, children: (0, jsx_runtime_1.jsx)(inputCardRadio_1.InputCardRadio, { id: `radio-class-${item.value}`, name: "radio-classes", title: item.title, value: item.value, isChecked: item.value === classType, isDisabled: item.isDisabled, onChange: () => handleCardChange(item.value), children: !isMobile && item.description }) }, item.value));
                }) }), classType === types_1.ClassTypes.Specific && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: classes.length > 0 && ((0, jsx_runtime_1.jsx)(CheckboxList_1.default, { className: "_mt-4", children: classes.map((pageClassItem, index) => {
                        const isClassChecked = selectedClassesIds.includes(pageClassItem.id);
                        const hasOtherDrippingUsingClass = otherClassesBeingUsedIds.includes(pageClassItem.id);
                        return ((0, jsx_runtime_1.jsx)(CheckboxListItem_1.default, { checked: isClassChecked, label: (0, jsx_runtime_1.jsx)(defaultClass_1.default, { name: pageClassItem.name, isDefault: pageClassItem.defaultClass }), isLast: index === classes.length - 1, disabled: hasOtherDrippingUsingClass, onChange: ({ target }) => handleClassItemChange(pageClassItem, target.checked) }, pageClassItem.id));
                    }) })) }))] }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(mapStateToProps))(ClassSettings);
